/*jshint multistr: true */
/*jshint esversion: 6 */

window.responsiveEmbeds = function responsiveEmbeds() {


    // used for getting query parameter "href" for creating FB responsive DIV
    const getParameterByName = function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    // returns vimeo, youtube, CDN
    const getIFType = function getIFType(iframeURL) {

        if (iframeURL) {

            if (iframeURL.includes("youtube.com/embed")) {
                return "youtube";
            }

            if (iframeURL.includes("player.vimeo.com/video")) {
                return "vimeo";
            }

            if (iframeURL.includes("dailymotion.com/embed")) {
                return "dailymotion";
            }

            if (iframeURL.includes("google.com/maps/embed")) {
                return "googlemaps";
            }

            if (iframeURL.includes("giphy.com/embed")) {
                return "giphy";
            }

            if (iframeURL.includes("facebook.com/plugins/post")) {
                return "fb-post";
            }

            if (iframeURL.includes("facebook.com/plugins/video")) {
                return "fb-video";
            }
        }

        return false;
    };


    // lets get fixed values if iframe and calculate ratio
    const getIFratio = function getIFratio($iframe) {

        const iFwidth   = $iframe.attr("width");
        const iFheight  = $iframe.attr("height");
        const iFhasDim  = iFwidth !== undefined && iFheight !== undefined;

        let iFratio     = 56.25;
        // If iframe has width and height attr
        if (iFhasDim) {
            iFratio = iFheight / iFwidth * 100;
        }

        return iFratio;
    };


    // converts iframe embed to <div class="fb-post" data-href="..."> type
    const iFToHTML = function iFToHTML($iframe, iFsrc, iFType) {

        const decodedURL = decodeURIComponent(iFsrc);
        const href = getParameterByName("href", decodedURL);

        const htmlTemplate = `<div class="${iFType}" data-href="${href}" data-show-text="true"></div>`;

        $iframe.replaceWith(htmlTemplate);

        // doublecheck if FB SDK is loaded
        if (typeof(FB) != 'undefined' && FB !== null ) {
            FB.XFBML.parse();
        }
    };


    // calculate aspect ratio then reconstruct iframe and make it responsive
    const makeRespondiveIF = function makeRespondiveIF ($iframe, iFratio, iFType) {

        $iframe
            .addClass("rspIFrame__content")
            .wrap(
                `<div class="rspIFrame__container embeded_${iFType}" style="padding-bottom:${iFratio}%"></div>`
            );
    };

    const $container = $(".article__content"); // selector container to search
    const $iframes = $container.find("iframe"); // what to find (hint iframes)

    // find all iframes in container
    $iframes.each(function(index) {

        const $iframe = $(this);
        const iFsrc = $iframe.attr("src");

        const iFType = getIFType(iFsrc);

        // if iframe is not in supported types
        if (!iFType) { return; }

        if (iFType == "fb-post" || iFType == "fb-video") {

            iFToHTML($iframe, iFsrc, iFType);

        } else {

            const iFratio = getIFratio($iframe);
            makeRespondiveIF($iframe, iFratio, iFType);
        }
    });
};



$(document).ready(function(){
    responsiveEmbeds();
})